$(function () {
  renderMarkdown($('#footer-text'), $.polyglot.t('footer_text', $.interpolations));
  renderMarkdown($('#footer_links'), $.polyglot.t('footer_links', $.interpolations));
  renderMarkdown($('#ecommerce-order-confirmation-explanation'), $.polyglot.t('ecommerce_order_confirmation_explanation', $.interpolations));
  renderMarkdown($('#create-account-benefits'), $.polyglot.t('create_account_benefits', $.interpolations));
  renderMarkdown($('#ecommerce-top-bar'), $.polyglot.t('ecommerce_top_bar', $.interpolations));
});
 $(function() {

  $('.mobile-sidebar-toggler').on('click', function(){
    $('body.ecommerce').toggleClass('sidebar-open');
  });

  $('.mobile-search-filters-toggle').on('click', function(){
    $('body.ecommerce').toggleClass('search-filters-open');
  });

    $(".pdp-add-to-cart-btn").on('click', function() {
        $(window).resize();
    });

    $(".search-items .pdp-add-to-cart-btn").on('click', function() {
        searchAddCart();
    });

  $(document).on("click", ".payment-promo-link", function(e) {
    e.preventDefault();
    $(".promo-payment-drop").toggle();
    $(".payment-promo-link").hide();
  })

  $('.pdp-section-header').on('click', function(){
      $(this).children('.expand-icon').toggleClass('fa-minus fa-plus');
  });

  $('*[data-toggle="collapse"]').on('click', function(){
    $(this).parent('.collapse-section').children('.expand-icon').toggleClass('fa-minus fa-plus');
  });
  $('*[data-toggle="collapse"]').on('click', function(){
    $(this, '.expand-icon').toggleClass('fa-minus fa-plus');
  });
  $('.footer-links .expand-section').on('click', function(){
    $(this).children('.expand-icon').toggleClass('fa-minus fa-plus');
      $(this).removeClass('fa-minus');
      $(this).removeClass('fa-plus');
  });

    $('.sidebar-expand-section').on('click', function(){
        if($(this).find('i').hasClass('fa-plus')) {
            $(this).find('i').removeClass('fa-plus');
            $(this).find('i').addClass('fa-minus');
        }
        else {
            $(this).find('i').removeClass('fa-minus');
            $(this).find('i').addClass('fa-plus');
        }
    });


    $('.checkbox-same-shipping').on('click', function(){
        var payReviewHeight = $('#billing-address-form').height();
        var payReviewState;
        if(payReviewState != "yes") {
            $('footer').css('margin-top', payReviewHeight + 'px');
            payReviewState = "yes";
        }
        else {
            $('footer').css('margin-top', '0px');
            payReviewState = "no";
        }
    });

  $('.mobile-sidebar-toggler').on('click', function(){
    $(this).children('.fal').toggleClass('fa-bars fa-times');
  });

  $('.search-cards').on('click', function(){
    $('.search-results').addClass('search-cards');
    $('.search-cards-icon').addClass('text-primary');
    $('.search-results').removeClass('search-list');
    $('.search-list-icon').removeClass('text-primary');
  });

  $('.search-list').on('click', function(){
    $('.search-results').addClass('search-list');
    $('.search-list-icon').addClass('text-primary');
    $('.search-results').removeClass('search-cards');
    $('.search-cards-icon').removeClass('text-primary');
  });

  $('.menu-nav-md .nav').find('> li').on('click', function () {
      $('.nav > li').not(this).find('ul').removeClass('nav-sublist-open');
      $('.nav > li').not(this).find('.nav-list-item-link-icon').removeClass('fa-angle-up');
      $('.nav > li').not(this).find('.nav-list-item-link-icon').addClass('fa-angle-down');
      $('.nav > li').not(this).find('.nav-list-item-link').removeClass('text-primary');
      $(this).find('ul').stop(true, true).toggleClass('nav-sublist-open');
      $(this).find('.nav-list-item-link-icon').stop(true, true).toggleClass('fa-angle-down fa-angle-up');
      $(this).find('.nav-list-item-link').stop(true, true).toggleClass('text-primary');
      return false;
  });

    $('.menu-nav-md .nav .nav-list-item-link').on('click', function() {
        var prodfeatArr = [];
       $(this).parent('li.nav-list-item').find('img.img-details').each(function(obj) {
           var prodfeatName = $(this).data('pname');
           var prodfeatSku = $(this).data('psku');
           var prodfeatCat = $(this).data('pcat');
           var prodfeatI = $(this).data('pipos');
           var prodfeatObj = {
               id: prodfeatSku,
               name: prodfeatName,
               category: prodfeatCat,
               brand: '',
               list: 'Navigation',
               position: prodfeatI
           }
           prodfeatArr.push(prodfeatObj);
       });
       if(prodfeatArr.length > 0) {
           gtmRecTag(prodfeatArr);
       }
    });

  $('ul.nav-sublist li a').on('click', function() {
    var navurl = $(this).attr('href');
    document.location.href = navurl;
  });

  $(window.document).on('click', function(){
    if( $(".nav-sublist").hasClass("nav-sublist-open") ){
      $(".nav-sublist").removeClass("nav-sublist-open");
      $(".nav-list-item-link").removeClass("text-primary");
      $(".nav-list-item-link-icon").removeClass("fa-angle-up");
      $(".nav-list-item-link-icon").addClass("fa-angle-down");
    };
  });

  $(".pdp-add-to-cart-btn").on('click', function () {
    disableButton();
  });

  function disableButton(){
    if ($("#add-to-cart-modal").is(":visible") && sessionStorage.clickcount == 1) {
      $('.pdp-add-to-cart-btn').removeClass('disable-pointer');
      $('.pdp-add-to-cart-btn').prop('disabled', false);
      sessionStorage.clickcount = 0;
    } else {
      $('.pdp-add-to-cart-btn').addClass('disable-pointer');
      $('.pdp-add-to-cart-btn').prop('disabled', true);
      sessionStorage.clickcount = 1;
    }
}


  if (typeof lightSlider === 'function') {
      $("#lsAtcRecommended").lightSlider({
          item: 4,
          slideMove: 4,
          slideMargin: 5,
          nextHtml: "<i class='fas fa-arrow-circle-right text-dark fa-2x'></i>",
          prevHtml: "<i class='fas fa-arrow-circle-left text-dark fa-2x'></i>",
          responsive: [
              {
                  breakpoint: 768,
                  settings: {
                      item: 2,
                      slideMove: 2,
                      slideMargin: 6,
                  }
              }
          ]
      });

      $("#lsPdpGallery").lightSlider({
          item: 4,
          controls: false,
          responsive: [
              {
                  breakpoint: 1600,
                  settings: {
                      item: 5,
                      slideMove: 5,
                      slideMargin: 6,
                  }
              },
              {
                  breakpoint: 1200,
                  settings: {
                      item: 4,
                      slideMove: 4,
                      slideMargin: 6,
                  }
              },
              {
                  breakpoint: 992,
                  settings: {
                      item: 4,
                      slideMove: 4,
                      slideMargin: 6,
                  }
              },
              {
                  breakpoint: 768,
                  settings: {
                      item: 4,
                      slideMove: 4,
                      slideMargin: 6,
                  }
              },
              {
                  breakpoint: 500,
                  settings: {
                      item: 3,
                      slideMove: 3,
                      slideMargin: 6,
                  }
              }
          ]
      });

  }

    $('.bestSellersSlider').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 3,
        dots: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 780,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            }
        ]
    });

   $(window).on("load",function () {

    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('.aura-header').height();
    var overviewHeight = $('.product-overview').height();
    var stickyHeight = (navbarHeight + overviewHeight);

    $(window).on('scroll', function (event) {
      didScroll = true;
    });

    setInterval(function () {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);

    function hasScrolled() {
      var st = $(this).scrollTop();

      // Make sure they scroll more than delta
      if (Math.abs(lastScrollTop - st) <= delta)
        return;

      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      if (st > lastScrollTop && st > stickyHeight) {
        // Scroll Down
        $('body.ecommerce #product-sticky-header').addClass('d-md-block').addClass('sticky');
      } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
            var hashLoc = window.location.hash;
            if(hashLoc == '#product-info-highlights' ||
                hashLoc == '#product-included' ||
                hashLoc == '#product-overview' ||
                hashLoc == '#product-specs' ||
                hashLoc == '#product-info-highlights' ||
                hashLoc == '#pdp-section-shipping' ||
                hashLoc == '#pdp-section-returns') {
                if (st < lastScrollTop && st < stickyHeight) {
                    $('body.ecommerce #product-sticky-header').removeClass('d-md-block').removeClass('sticky');
                }
            }
            else {
                $('body.ecommerce #product-sticky-header').removeClass('d-md-block').removeClass('sticky');
            }
        }
      }

      lastScrollTop = st;
    }
  });

  $('#lsPdpGallery').on('img', 'click', function () {
    $('#ex1').addClass('d-inline-block');
    $('#ex1').removeClass('d-none');
    $('#gallery-video').removeClass('d-flex');
    $('#gallery-video').addClass('d-none');
    $('.largeImage').attr('src', $(this).attr('src').replace('thumb', 'large'));
    $('.zoomImg').attr('src', $(this).attr('src').replace('thumb', 'large'));
    $('#gallery-video-embed').removeAttr('src');
  });

  $('.carousel-item-outer').on('click', function(){
    $('.carousel-item-outer').removeClass('selected');
    $(this).addClass('selected');
  });

  $(".video-embed").on('click', function(){
    var video_id = $(this).data('vid');
    $('#ex1').addClass('d-none');
    $('#ex1').removeClass('d-inline-block');
    $('#gallery-video').removeClass('d-none');
    $('#gallery-video').addClass('d-flex');
    $('#gallery-video-embed').attr('src', 'https://www.youtube.com/embed/' + video_id );
  });

});

var pathname = window.location.pathname;

var mobSearch = function() {
    window.location.href = "/products_search";
}

var searchDirect = function() {
    var searchTerm = $('#search').val();
    var searchLink = '/products_search/?se=' + searchTerm;
    window.location.href = searchLink;
}

$('.searchHand').on('submit', function(e) {
    e.preventDefault();
    var accessTerm = $('.search-key-com').val();
    var searchLinkM = '/products_search/?se=' + accessTerm;
    //$(this).append('Mobile Search Term: ' + accessTerm + '<br>');
    window.location.href = searchLinkM;

});

if(pathname != '/products_search' && pathname != '/products_search/') {
  $('.desktop-only #btn-search').on('click', function() {
    searchDirect();
  });
  $('.desktop-only #search').on('keydown', function (e) {
      var key = e.which;
      if(key == 13 || key == 229) {
          searchDirect();
      }
  });
}

$('.breadcrumb-back a').on('click', function(e) {
    e.preventDefault();
    var url = document.referrer;
    var domainCatch = document.referrer.split('/')[2];
    if (domainCatch.indexOf("fujifilm") >= 0) {
        window.history.back();
    }
    else {
        window.location = '/';
    }
});

$('body.fps-checkout-page .brand-logo-anchor').on( 'click', function(e) {
    e.preventDefault();
    var winAnchorOut = window.open('https://www.fujifilm.com/', '_blank');
    winAnchorOut.focus();
});

$('.pdp-dealer-btn').on('click', function(e) {
  e.preventDefault();
  var url = 'https://fujifilm-x.com/en-us/shop/';
  window.open(url, '_blank');
});

$('input.vradisabled').attr('disabled', 'disabled');

$('body.ecommerce-home-page .pdp-section-header h3').text('Best Sellers');

// Fixed payment summary on scroll
var page_window_width_mob = $(window).width();

var wrapheight =  $('.page-wrap').height();

if(wrapheight > 750 && page_window_width_mob > 770) {

  $(function($) {
    var pWidth =  $('#ecommerce_payment_summary').width() + 'px';
    var fHeight =  $('.aura-footer-inner').height();
    var scrollBottom = $(window).scrollTop() + $(window).height();
    $(window).on('scroll', function fix_element() {
        var page_origin = window.location.origin;
        var windowScrollMargin;
        if((page_origin.indexOf('olympus') >= 0) || (page_origin.indexOf('omprotect') >= 0) || (page_origin.indexOf('omsystem') >= 0)) {
          var headerHeight = $('.aura-header').height();
          var heroBannerHeight = $('.aura-content-wrapper').prev().height();
          var contentHeaderHeight =  $('.aura-content').prev().height();
          var scrollMargin = headerHeight + heroBannerHeight + contentHeaderHeight;
          windowScrollMargin = scrollMargin;
        } else {
          windowScrollMargin = 300;
        }
        if($(window).scrollTop() > windowScrollMargin) {
          $('#ecommerce_payment_summary').css('position', 'fixed');
          $('#ecommerce_payment_summary').css('width', pWidth);
        }
        else {
          $('#ecommerce_payment_summary').css('position', 'relative');
        }
      return fix_element;
    }());
  });

  $(window).on('scroll', function() {
    topOfFooter = $('footer').position().top;
    var sidebarheight =  $('#ecommerce_payment_summary').height() + 45;
    $('#ecommerce_payment_summary').css('top', '10px');
    scrollDistanceFromTopOfDoc = $(document).scrollTop() + sidebarheight;
    scrollDistanceFromTopOfFooter = scrollDistanceFromTopOfDoc - topOfFooter;
    if (scrollDistanceFromTopOfDoc > topOfFooter) {
      $('#ecommerce_payment_summary').css('margin-top',  0 - scrollDistanceFromTopOfFooter);
    } else  {
      $('#ecommerce_payment_summary').css('margin-top', 0);
    }
  });


  var payHeight = $('.aura-container .checkout-summary-full').height();
  var payFullHeight = payHeight + 'px';
  //$('.aura-container .checkout-summary-full').css('height', payFullHeight);

}

 $(function() {
    if(page_window_width_mob < 770) {
        $('.nav-dropdown-user').on('click', function() {
            $('body').append('<div class="modal-backdrop fade show" style="z-index:140;opacity:.8;"></div>')
            $('.dropdown-user').addClass('fade show');
        });

        $('.mobile-search-filters-toggle').on('click', function() {
            //$('body').append('<div class="modal-backdrop fade show" style="z-index:140;opacity:.8;"></div>');
        });

        $('.main-nav-toggler').on('click', function() {
            $('body').append('<div class="modal-backdrop fade show" style="z-index:140;opacity:.8;"></div>');
        });

        $('.navbar-toggler').on('click', function() {
            $('body').append('<div class="modal-backdrop fade show" style="z-index:140;opacity:.8;"></div>');
        });

        // If mobile collapse all PDP info sections on page load
        $('.pdp-section-expand').removeClass('show');
        $('.pdp-section-expand').closest('section').find('.pdp-section-header').append('<i class="expand-icon fas ml-auto fa-plus" aria-hidden="true"></i>');

    }
});


$('.user-menu button.close').on('click', function() {
    $('.user-menu').removeClass('dropdown-menu-open');
    $('body').find('.modal-backdrop').remove();
    $('body').trigger('click');
});

$('.mobile-search-filters-close').on('click', function() {
    $('body').removeClass('search-filters-open');
    $('body').find('.modal-backdrop').remove();
});

$('.mobile-main-nav-close').on('click', function() {
    $('body').removeClass('sidebar-open');
    $('body').find('.modal-backdrop').remove();
});

// $('body').click(function(){
//     if($('body').hasClass('ecommerce-search-page')) {
//         //$('body').find('.modal-backdrop').remove();
//     }
//     else {
//         $('body').find('.modal-backdrop').remove();
//     }
// });

$(document).on('mouseup', function(e)
{
    var container = $(".modal-dialog");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('body').find('.modal-backdrop').remove();
    }
});

// The function actually applying the offset
function offsetAnchor() {
    if (location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 200);
    }
}

// Captures click events of all <a> elements with href starting with #
$('.pdp-sticky-header-nav').on('click', 'a[href^="#"]', function(event) {
    // Click events are captured before hashchanges. Timeout
    // causes offsetAnchor to be called after the page jump.
    window.setTimeout(function() {
        offsetAnchor();
    }, 0);
});

var pathglobal_name = window.location.pathname;
if(pathglobal_name != '/products_cart' && pathglobal_name != '/products_payment') {
    // If user is not on cart or checkout page set session referrer var
    sessionStorage.setItem("cartReferrer", pathglobal_name);
}

// Continue Shopping cart / checkout link
var continueLink = function() {
    var pathname = window.location.pathname;
    if(pathname == '/products_cart' || pathname == '/products_payment') {
        var catchCartReferrer = sessionStorage.getItem('cartReferrer');
        if(catchCartReferrer.length > 0) {
            window.location.href = catchCartReferrer;
        }
        else {
            window.location.href = '/products_home';
        }
    }
}

$('.cart-continue-link a').on('click', function() {
    continueLink();
});

$(".sliding-link").on('click', function(e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $('html,body').animate({scrollTop: $(aid).offset().top},'slow');
});

 $(function() {
    var catchPromo = sessionStorage.getItem('promo_primary');
    var yousavedAmount;
    yousavedAmount = $('.you-saved-amount').text();
    if(yousavedAmount != '$0.00') {
      if(catchPromo != '' && catchPromo != null) {
        $('.promo-status').append('<p>Promo Applied: ' + catchPromo + '</p>');
        $('.payment-promo-drop, .payment-promo-link').hide();
      }
    }
})

$.fn.isOnScreen = function(){
    var win = $(window);
    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();
    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};

$('.pdp-attribute-1 .custom-radio input[type=radio]').on('click', function() {
    if($(this).data('attr-active') == 'true') {
        $(this).prop('checked', false);
        $(this).data('attr-active', 'false');
        $(this).parents('.pdp-attribute-1').find('.bundle-title-2 span').html('');
    } else {
        $(this).data('attr-active', 'true');
    }
});

$('.logout-link').on('click', function(e) {
  e.preventDefault();
  $('#logout_form').submit();
});

function formatShipDate(date) {
  var shipRep = date.replaceAll('-', '/');
  var shipGroundObj = shipRep.split("/");
  var shipGroundText = shipGroundObj[1] + '/' + shipGroundObj[2] + '/' + shipGroundObj[0];
  var shipGroundDate = new Date(shipGroundText) + '';
  var shipGround = shipGroundDate.split('00:00:00');
  var shipGrFull = shipGround[0];
  var shipGroundFinal = shipGrFull.substring(0, shipGrFull.length - 5);
  var shipGroundSplit = shipGrFull.split(' ');
  return (shipGroundSplit[0] + ', ' + shipGroundSplit[1] + ' ' + shipGroundSplit[2]);
}

function addDaysDate(fDate, numDays) {
  var date = fDate;
  var year = date.getFullYear();
  var month = ("0" + (date.getMonth() + 1)).slice(-2);
  var day = ("0" + (date.getDate() + numDays)).slice(-2);
  var daysh = new Date();
  var dayshort = daysh.setDate(date.getDate() + numDays);
  var dayshort = daysh.toLocaleDateString('en-US', { weekday: 'short' });
  var finaldate = dayshort + '. ' + month + '/' + day;
  return finaldate;
}

function errZipMsg(loc) {
  $('.zip-error-msg').append('Thank you for your interest in purchasing a Fujifilm product. Unfortunately, we do not ship to ' + loc + ' at this time.');
  $('.zip-error-msg').show();
  $('.fedex-delivery-dates').hide();
}

var calculateShipDates = function(zip) {
  if(zip.length < 1) { zip = '90210';}
  var zipFindVar = zip.substring(0,3);
  if(zipFindVar == '006' || zipFindVar == '007' || zipFindVar == '009') {
    errZipMsg('Puerto Rico');
  }
  else {
    return $.ajax({
      url: '/server_side_carts/shipping_estimate/guest',
      type: 'POST',
      beforeSend: function(xhr) {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
      },
      data: { zip_code: zip, country_code: "US"},
      dataType: "json",
      success: function(data){
        console.log(data);
      },
      error: function(data) {
        console.log(data);
      }
    })
      .done(function(data) {
        var shipGroundMinEst = data.FEDEX_GROUND.delivery_estimate.min;
        var shipGroundMaxEst = data.FEDEX_GROUND.delivery_estimate.max;
        var shipGroundAm = data.FEDEX_GROUND.amount;
        var shipTwoDayMinEst = data.FEDEX_2_DAY.delivery_estimate.min;
        var shipTwoDayMaxEst = data.FEDEX_2_DAY.delivery_estimate.max;
        var shipTwoDayAm = data.FEDEX_2_DAY.amount;
        var shipMinGround = formatShipDate(shipGroundMinEst);
        var shipMaxGround = formatShipDate(shipGroundMaxEst);
        var shipMinTwoDay = formatShipDate(shipTwoDayMinEst);
        var shipMaxTwoDay = formatShipDate(shipTwoDayMaxEst);
        var shipMinGroundShort = dayjs(shipGroundMinEst).format("ddd, MM/DD");
        var shipMaxGroundShort = dayjs(shipGroundMaxEst).format("ddd, MM/DD");
        var shipMinTwoDayShort = dayjs(shipTwoDayMinEst).format("ddd, MM/DD");
        var shipMaxTwoDayShort = dayjs(shipTwoDayMaxEst).format("ddd, MM/DD");


        $("#order_est_delivery strong").html(shipMaxGround);
        $('#ship-ground-mark').html(shipMaxGround);
        $('#ship-two-day-mark').html(shipMaxTwoDay);
        $('#ship-ground-mark-checkout, .ship-copy-ground').html('Est. Arrival: ' + shipMinGroundShort + ' - ' + shipMaxGroundShort);
        $('#ship-two-day-mark-checkout, .ship-copy-two-day').html('Est. Arrival: ' + shipMinTwoDayShort + ' - ' + shipMaxTwoDayShort);
        $('.fedex-delivery-dates').css('opacity', '1');
      })
      .fail(function(data) {
        $('.fedex-delivery-dates').css('opacity', '0');
        $('.fedex-delivery-dates').slideUp();
      });
  }
}
